import script from "./CloseBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CloseBtn.vue?vue&type=script&setup=true&lang=js"

import "./CloseBtn.vue?vue&type=style&index=0&id=238997cf&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238997cf"]])

export default __exports__